"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STAKE_CAPS_PARAMETERS_PROGRAM_ADDRESS = exports.GOVERNANCE_ADDRESS = exports.PUBLISHER_CAPS_PROGRAM_ADDRESS = exports.INTEGRITY_POOL_PROGRAM_ADDRESS = exports.STAKING_PROGRAM_ADDRESS = exports.POSITIONS_ACCOUNT_SIZE = exports.POSITIONS_ACCOUNT_HEADER_SIZE = exports.POSITION_BUFFER_SIZE = exports.FRACTION_PRECISION_N = exports.FRACTION_PRECISION = exports.MAX_VOTER_WEIGHT = exports.EPOCH_DURATION = exports.ONE_YEAR_IN_SECONDS = void 0;
const anchor_1 = require("@coral-xyz/anchor");
const web3_js_1 = require("@solana/web3.js");
const ONE_MINUTE_IN_SECONDS = 60n;
const ONE_HOUR_IN_SECONDS = 60n * ONE_MINUTE_IN_SECONDS;
const ONE_DAY_IN_SECONDS = 24n * ONE_HOUR_IN_SECONDS;
const ONE_WEEK_IN_SECONDS = 7n * ONE_DAY_IN_SECONDS;
exports.ONE_YEAR_IN_SECONDS = 365n * ONE_DAY_IN_SECONDS;
exports.EPOCH_DURATION = ONE_WEEK_IN_SECONDS;
exports.MAX_VOTER_WEIGHT = 10000000000000000n; // 10 Billion with 6 decimals
exports.FRACTION_PRECISION = 1_000_000;
exports.FRACTION_PRECISION_N = 1000000n;
exports.POSITION_BUFFER_SIZE = 200;
exports.POSITIONS_ACCOUNT_HEADER_SIZE = anchor_1.DISCRIMINATOR_SIZE + 32;
exports.POSITIONS_ACCOUNT_SIZE = anchor_1.DISCRIMINATOR_SIZE + 32;
exports.STAKING_PROGRAM_ADDRESS = new web3_js_1.PublicKey("pytS9TjG1qyAZypk7n8rw8gfW9sUaqqYyMhJQ4E7JCQ");
exports.INTEGRITY_POOL_PROGRAM_ADDRESS = new web3_js_1.PublicKey("pyti8TM4zRVBjmarcgAPmTNNAXYKJv7WVHrkrm6woLN");
exports.PUBLISHER_CAPS_PROGRAM_ADDRESS = new web3_js_1.PublicKey("pytcD8uUjPxSLMsNqoVnm9dXQw9tKJJf3CQnGwa8oL7");
exports.GOVERNANCE_ADDRESS = new web3_js_1.PublicKey("pytGY6tWRgGinSCvRLnSv4fHfBTMoiDGiCsesmHWM6U");
exports.STAKE_CAPS_PARAMETERS_PROGRAM_ADDRESS = new web3_js_1.PublicKey("ujSFv8q8woXW5PUnby52PQyxYGUudxkrvgN6A631Qmm");
